import { createFileRoute } from '@tanstack/react-router'
import { DepotForm } from '@features/stock/components/DepotForm'
import { useQuery } from '@tanstack/react-query'
import api from '@lib/utils/api'
import { queryKeys } from '@lib/api/queryKeys'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/depots/$id/edit')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.DEPOTS.EDIT, context)
  },
  component: EditDepotComponent,
})

function EditDepotComponent() {
  const { id } = Route.useParams()
  const { canEdit } = usePermissions()
    
  const { data } = useQuery({
    queryKey: queryKeys.stock.depots.details(Number(id)),
    queryFn: async () => {
      const response = await api.get(`/depots/${id}`)
      return response.data
    },
  })

  if (!canEdit('stock.depots.edit')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Modifier Dépôt</h1>
      {data && <DepotForm mode="edit" initialData={data} />}
    </div>
  )
}
